import { memo, useState } from 'react'
import { UserContext } from '../contexts/UserContext'

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const saved = localStorage.getItem('varBackofficeeasy')
      return saved ? JSON.parse(saved) : null
    } catch {
      return null
    }
  })
  
  const [retardCall, setRetardCall] = useState(() => {
    try {
      const saved = localStorage.getItem('retardCall')
      return saved ? JSON.parse(saved) : 0
    } catch {
      return 0
    }
  })

  return (
    <UserContext.Provider value={{ user, setUser , setRetardCall, retardCall}}>
      {children}
    </UserContext.Provider>
  )
}

export default memo(AuthProvider)
